import React from 'react';
import HeroSectionNoLink from '../components/HeroSectionNoLink';

const HeroModule = function () {
  return <HeroSectionNoLink />;
};

export default HeroModule;
